import { defineStore } from 'pinia'

export type ItemSearchViewType = 'grid' | 'panel' | 'table' | 'map'

export function toQueryStrWoPage(q: SearchQuery) {
  return toSearchQueryString(q)
    .replace(/&?from=\d+|&?size=\d+/g, '')
    .replace(/g-loc=.+?km/, 'g-loc=')
}

const LOCAL_SEARCH_LSKEY = 'jps-local-search-v4'

interface LocalSearch {
  searchHistory: SearchQuery[]
  activeMySearch?: string
  preference: {
    searchView: ItemSearchViewType
    pageSize: number
  }
}

/**
 * 検索のPreferenceを管理するためのStateStore
 */
export const useLocalSearchStore = defineStore('local-search', () => {
  function saveSearch(s: LocalSearch) {
    lsSet(LOCAL_SEARCH_LSKEY, s)
  }

  let _localSearch = null
  if (import.meta.client) {
    _localSearch = lsGet<LocalSearch>(LOCAL_SEARCH_LSKEY)
    if (!_localSearch) {
      _localSearch = {
        searchHistory: [],
        activeMySearch: null,
        preference: {
          searchView: 'grid',
          pageSize: 20,
        },
      }
      saveSearch(_localSearch)
    }
  }

  const localSearch = reactive<LocalSearch>(_localSearch)

  const searchView = computed({
    get: () => localSearch?.preference.searchView,
    set: v => {
      localSearch.preference.searchView = v
      saveSearch(localSearch)
    },
  })

  const pageSize = computed({
    get: () => localSearch?.preference.pageSize,
    set: v => {
      localSearch.preference.pageSize = v
      saveSearch(localSearch)
    },
  })

  const activeMySearch = computed({
    get: () => localSearch?.activeMySearch,
    set: v => {
      localSearch.activeMySearch = v
      saveSearch(localSearch)
    },
  })

  //検索履歴
  function addSearchHistory(q: SearchQuery) {
    if (
      q &&
      q.csid &&
      q.csid !== systemGallerySearchId() &&
      !q.csid.startsWith('jpsmys-')
    ) {
      let target: SearchQuery = clone(q)
      target.from = 0
      let newQstr = toQueryStrWoPage(target)
      let historyQstr = localSearch.searchHistory.map(query => toQueryStrWoPage(query))
      let index = historyQstr.indexOf(newQstr)
      if (index === -1) {
        localSearch.searchHistory.unshift(target)
      } else {
        localSearch.searchHistory.splice(index, 1)
        localSearch.searchHistory.unshift(target)
      }
      localSearch.searchHistory = localSearch.searchHistory.slice(0, 30)
      saveSearch(localSearch)
    }
  }

  const history = computed(() => localSearch.searchHistory)

  function clearHistory() {
    localSearch.searchHistory = []
    saveSearch(localSearch)
  }

  const _globalScrollAfterSearch: Ref<boolean> = ref(false)
  const globalScrollAfterSearch = computed<boolean>({
    get: () => _globalScrollAfterSearch.value,
    set: v => _globalScrollAfterSearch.value = v
  })

  return {
    searchView,
    pageSize,
    activeMySearch,
    addSearchHistory,
    history,
    clearHistory,
    globalScrollAfterSearch,
  }
})
